/**
 * The tab panel, re-exported from Radix.
 *
 * Separate from `Tabs.tsx` so that file exports a single component — the lint
 * rule cannot tell a re-exported component from a re-exported constant, and a
 * mixed module defeats fast refresh either way.
 */
import * as RadixTabs from '@radix-ui/react-tabs';

export const TabPanel = RadixTabs.Content;
